import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-media-control',
    templateUrl: './media-control.component.html',
    styleUrls: ['./media-control.component.scss'],
    standalone: false
})
export class MediaControlComponent implements OnInit {
  @Input() duration: number = 0;
  @Input() currentTime: number = 0;
  @Input() progressValue: number = 0;
  @Input() underPlay: boolean = false;
  @Output() paused = new EventEmitter<{underPlay: boolean, loadNew: boolean}>();
  @Output() played = new EventEmitter<{underPlay: boolean}>();

  constructor() { }

  ngOnInit() { }

  onPause() {
    this.underPlay = false;
    this.paused.emit({underPlay: this.underPlay, loadNew: false});
  }
  onPlay() {
    if (this.currentTime != this.duration) {
      this.underPlay = true;
      this.played.emit({underPlay: this.underPlay});
    }
  }

}
